import { useMemo } from 'react';

export const useTooltipArrow = (position: string) => {
  const arrowStyles = useMemo(() => {
    const arrowSize = 8;
    const arrowOffset = arrowSize / 2;
    // Misma superficie que el globo (`useTooltipClasses`: `ui-bg-canvas-inverse`).
    const arrowColor = 'var(--ui-color-bg-canvas-inverse)';
    const borderRadius = '2.5px'; // Redondeo más pronunciado en la punta

    // Estilos base del cuadrado rotado
    const baseStyles = {
      position: 'absolute' as const,
      width: `${arrowSize}px`,
      height: `${arrowSize}px`,
      backgroundColor: arrowColor,
      borderRadius,
    };

    switch (position) {
      case 'top':
        return {
          ...baseStyles,
          bottom: `-${arrowOffset}px`,
          left: '50%',
          transform: 'translateX(-50%) rotate(45deg)',
        };
      case 'bottom':
        return {
          ...baseStyles,
          top: `-${arrowOffset}px`,
          left: '50%',
          transform: 'translateX(-50%) rotate(45deg)',
        };
      case 'left':
        return {
          ...baseStyles,
          right: `-${arrowOffset}px`,
          top: '50%',
          transform: 'translateY(-50%) rotate(45deg)',
        };
      case 'right':
        return {
          ...baseStyles,
          left: `-${arrowOffset}px`,
          top: '50%',
          transform: 'translateY(-50%) rotate(45deg)',
        };
      case 'top-left':
        return {
          ...baseStyles,
          bottom: `-${arrowOffset}px`,
          left: '12px',
          transform: 'rotate(45deg)',
        };
      case 'top-right':
        return {
          ...baseStyles,
          bottom: `-${arrowOffset}px`,
          right: '12px',
          transform: 'rotate(45deg)',
        };
      case 'bottom-left':
        return {
          ...baseStyles,
          top: `-${arrowOffset}px`,
          left: '12px',
          transform: 'rotate(45deg)',
        };
      case 'bottom-right':
        return {
          ...baseStyles,
          top: `-${arrowOffset}px`,
          right: '12px',
          transform: 'rotate(45deg)',
        };
      case 'right-top':
        return {
          ...baseStyles,
          left: `-${arrowOffset}px`,
          top: '8px',
          transform: 'rotate(45deg)',
        };
      case 'right-bottom':
        return {
          ...baseStyles,
          left: `-${arrowOffset}px`,
          bottom: '8px',
          transform: 'rotate(45deg)',
        };
      case 'left-top':
        return {
          ...baseStyles,
          right: `-${arrowOffset}px`,
          top: '8px',
          transform: 'rotate(45deg)',
        };
      case 'left-bottom':
        return {
          ...baseStyles,
          right: `-${arrowOffset}px`,
          bottom: '8px',
          transform: 'rotate(45deg)',
        };
      default:
        return {};
    }
  }, [position]);

  return arrowStyles;
};
